module.exports = __webpack_public_path__ + "003-gold-medal.73037d0d.svg";